export const LOGIN_ROUTE = '/login';
export const SIGNUP_ROUTE = '/sign-up';
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const SIGNUP_CREATE_ACCOUNT_ROUTE = '/sign-up/create-account';
export const SIGNUP_CHECKOUT_ROUTE = '/sign-up/checkout';
export const SIGNUP_COMPLETE_ROUTE = '/sign-up/complete';
export const NDC_SIGNUP_CREATE_ACCOUNT_ROUTE = '/ndc-institute/sign-up/create-account';
export const NDC_SIGNUP_CHECKOUT_ROUTE = '/ndc-institute/sign-up/checkout';
export const NDC_SIGNUP_COMPLETE_ROUTE = '/ndc-institute/sign-up/complete';

export const AUTH_NO_NAVBAR_PATHS = [
	LOGIN_ROUTE,
	FORGOT_PASSWORD_ROUTE,
	RESET_PASSWORD_ROUTE,
	SIGNUP_CREATE_ACCOUNT_ROUTE,
	SIGNUP_CHECKOUT_ROUTE,
	SIGNUP_COMPLETE_ROUTE,
	NDC_SIGNUP_CREATE_ACCOUNT_ROUTE,
	NDC_SIGNUP_CHECKOUT_ROUTE,
	NDC_SIGNUP_COMPLETE_ROUTE,
] as const;

// Only used to normalise a candidate path; nothing is ever sent to it.
const RETURN_PATH_BASE = 'https://return-path.invalid';

/** The path, query and hash `value` resolves to, or null if it resolves anywhere but this site. */
const toLocalPath = (value: string): string | null => {
	let url: URL;
	try {
		url = new URL(value, RETURN_PATH_BASE);
	} catch {
		return null;
	}
	return url.origin === RETURN_PATH_BASE ? url.pathname + url.search + url.hash : null;
};

/** Where to send someone after login: the page they came from, if it normalises to a path on this site. */
export const safeReturnPath = (value: string | null | undefined): string => {
	// Backslashes and control characters let a "path" normalise into another host.
	const hasUnsafeCharacter = (s: string) =>
		[...s].some((c) => c === '\\' || c.charCodeAt(0) < 0x20 || c.charCodeAt(0) === 0x7f);
	if (!value || !value.startsWith('/') || hasUnsafeCharacter(value)) {
		return '/dashboard';
	}
	const path = toLocalPath(value);
	// The returned string is what the browser navigates to, so it is validated as well: dot segments
	// can normalise "/x/..//host" to "//host", which the browser reads as another site.
	if (!path || path.startsWith('//') || toLocalPath(path) !== path) {
		return '/dashboard';
	}
	return path;
};

export const loginRouteReturningTo = (pathname: string, search: string): string =>
	`${LOGIN_ROUTE}?r=${encodeURIComponent(search ? `${pathname}?${search}` : pathname)}`;

export const PARENTS_PROGRAMS_ROUTE = '/parents/programs';
export const parentsProgramsRoute = (href: string) =>
	href?.startsWith('/') && !href.startsWith(PARENTS_PROGRAMS_ROUTE) ? `${PARENTS_PROGRAMS_ROUTE}${href}` : href;
